import { Box } from '@chakra-ui/react';

import style from './VendorRegistrationSection.style';
import { VendorRegistrationSectionProps } from './VendorRegistrationSection.type';

import { ContentfulRichText } from '@/components';

const VendorRegistrationSection = ({
  mainTitle,
  description,
}: VendorRegistrationSectionProps) => {
  return (
    <Box __css={style.contentSide}>
      {mainTitle && <ContentfulRichText document={mainTitle} />}
      {description && <ContentfulRichText document={description} />}
    </Box>
  );
};

export default VendorRegistrationSection;
